import { isLocalUrl, targetBlank, isMobileBreakpoint } from '../utils.js';

export default function cardWidget11() {
  const widgetName = 'cardWidget11';
  const widgetOpts = cardWidget11Opts;

  const isDesktopScreen = !isMobileBreakpoint;
  const wrapContainerClass = 'edge-to-edge-cards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: isDesktopScreen ? [] : ['all'],
    showDescription: false,
    moreButton: true,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      console.log(isDesktopScreen);
      if (hasData) {
        createCustomCards(data.items);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomCards(widgetData) {
    $widget.find('.image-container').append('<div class="overlay"></div>');
    $widget.find('.card-content').remove();

    $widget.find('.card-widget-item').each(function (x) {
      const { Title, URL } = widgetData[x];
      let urlAttribute = targetBlank(URL);

      const $cardItem = $(this);

      $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content">
              ${URL ? `<a href="${URL}" class="button" ${urlAttribute}>More</a>` : ''}
            </div>
          </div>`);

      if (isLocalUrl(URL)) {
        $cardItem.removeAttr('target');
      }
      if (URL) {
        $cardItem.addClass('only-url');
      } else {
        $cardItem.addClass('empty-card').removeAttr('href');
      }
    });
  }
}
